// frontend/packages/business-console/src/components/layout/districtMode.js
//
// "School district mode" (tenant feature `district_mode`). A school district
// runs its website from the Console but has no use for the small-business
// sales stack, so with the flag on the Console hides customers, estimates,
// invoices, payments, booking, workflow forms, Pulse, and AI visibility, and
// keeps the website tools (pages, events, documents, alerts, media, inbox,
// analytics).
//
// This is presentation only: the APIs behind the hidden pages are untouched,
// and a direct link to a hidden page redirects to Home (DistrictModeGate).
// One list, used by the sidebar, the mobile tab bar, Settings, and the route
// gate, so a page is hidden everywhere or nowhere.

export const DISTRICT_MODE_FEATURE = 'district_mode';

// pageConfig keys (and Settings section keys) hidden in district mode.
export const DISTRICT_HIDDEN_KEYS = new Set([
  'pulse',
  'create',
  'crm',
  'crm-customer',
  'quotes',
  'quotes-drafts',
  'quotes-new',
  'quote-detail',
  'quote-edit',
  'invoices',
  'invoices-drafts',
  'invoices-new',
  'invoice-detail',
  'invoice-edit',
  'payments',
  'forms',
  'forms-drafts',
  'forms-fill',
  'forms-ai-builder',
  'form-submission-detail',
  'scheduling',
  'uavs',
  'stripe-connect',
]);

export function isDistrictMode(features) {
  return Boolean(features && features[DISTRICT_MODE_FEATURE] === true);
}

export function hiddenInDistrictMode(key, features) {
  return isDistrictMode(features) && DISTRICT_HIDDEN_KEYS.has(key);
}
